import React, { memo, ReactElement } from 'react';
import { Box } from '@mui/material';
import { wrapper } from './FieldError.sx';

interface FormError {
  message?: string;
}

interface FieldErrorsProps {
  error: FormError | undefined;
}

const FieldError = memo(({ error }: FieldErrorsProps): ReactElement => {
  return (
    <>
      {error !== undefined && (
        <Box component={'pre'} sx={wrapper}>
          {error.message}
        </Box>
      )}
    </>
  );
});

export default FieldError;
